export default __webpack_public_path__ + "static/media/Speedee_Rg.ce55ee0e.ttf";